import { render, staticRenderFns } from "./FileCollectionForm.vue?vue&type=template&id=5c5b2c4c"
import script from "./FileCollectionForm.vue?vue&type=script&lang=ts"
export * from "./FileCollectionForm.vue?vue&type=script&lang=ts"
import style0 from "./FileCollectionForm.vue?vue&type=style&index=0&id=5c5b2c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports